module.exports = __webpack_public_path__ + "05_long_beige.354af8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/05_long_beige.png
// module id = GD0G
// module chunks = 0